<template>
  <div class="user-set main-panel large">
    <h1 class="panel-title">色卡新增列表</h1>
    <div class="top">
      <div class="form">
        <div class="row">
          <div class="item col-1">
            <div class="label">门店/仓存</div>
            <el-select
              v-model="md"
              placeholder="请选择门店"
              style="width: 100%"
              clearable
              filterable
            >
              <el-option
                v-for="item in menlist"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="item col-1">
            <div class="label">品名</div>
            <el-select
              v-model="pmname"
              placeholder="请选择品名"
              style="width: 100%"
              clearable
              filterable
            >
              <el-option
                v-for="item in pmlist"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="item col-1">
            <div class="form-options">
              <el-button size="small" class="custom-btn" @click="search"
                >查询</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-table :data="list" border style="width: 100%" class="custom-table">
      <el-table-column type="index" align="center" width="50" label="序号" />
      <el-table-column align="center" label="日期">
        <template #default="scope">
          {{ formatDate(scope.row.date) }}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="storeName" label="门店/仓存" />
      <el-table-column
        align="center"
        prop="productName"
        label="品名"
        show-overflow-tooltip
      />
      <el-table-column align="center" prop="number" label="数量" />
      <el-table-column align="center" label="操作">
        <template #default="scope">
          <div class="options">
            <i
              class="update-icon el-icon-edit"
              title="修改"
              @click="up(scope.row)"
            ></i>
            <el-popconfirm
              title="确认删除吗?"
              confirmButtonText="确认"
              cancelButtonText="取消"
              @confirm="delUser(scope.row.id)"
            >
              <template #reference>
                <i class="del-icon el-icon-close" title="删除"></i>
              </template>
            </el-popconfirm>
          </div>
        </template>
      </el-table-column>
      <!-- 加载更多插槽 -->
      <template #append>
        <div
          class="load-more"
          :class="{ 'no-more': noMore }"
          v-if="list.length"
          @click="loadMore"
        >
          {{ noMore ? "没有数据了~" : "点击加载下一页" }}
        </div>
      </template>
    </el-table>
    <el-dialog title="修改" center width="366px" v-model="dialogTableVisible">
      <div class="update-view">
        <div class="item">
          <span class="label" require>门店</span>
          <el-select
            size="mini"
            class="cg-input"
            filterable
            v-model="upmd"
            placeholder="请选择门店"
            style="padding: 4px 0"
          >
            <el-option
              v-for="item in menlist"
              :key="item.id"
              :label="item.name"
              :value="+item.id"
            />
          </el-select>
        </div>
        <div class="item">
          <span class="label" require>品名</span>
          <el-select
            v-model="uppmname"
            placeholder="请选择品名"
            style="width: 100%"
            clearable
          >
            <el-option
              v-for="item in pmlist"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
        <div class="item">
          <span class="label">数量</span>
          <label><input type="text" class="cg-input" v-model="num" /></label>
        </div>
        <div class="footer">
          <el-button class="custom-btn" size="small" @click="save"
            >保存</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, onMounted, getCurrentInstance, watch } from "vue";
const { proxy } = getCurrentInstance();

const dialogTableVisible = ref(false);
const uppmname = ref("");
const num = ref("");
const upmd = ref("");
const idx = ref(""); //色卡新增id
const list = ref([]); //表格数据列表
const pmname = ref(""); // 产品编号
const pmlist = ref([]);
const md = ref(""); //门店名称
const menlist = ref([]); //门店列表

// 分页变量
const pages = ref({ page: 1, size: 50 });
const noMore = ref(false);
const loading = ref(false);

// 缓存值
const STORAGE_KEY = "/publish-clothes/colorcard/colorcardAddList";

// 监听查询条件
watch([pmname, md], () => {
  const searchParams = {
    pmname: pmname.value,
    md: md.value,
  };
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(searchParams));
});

// 读取缓存回填表单
const loadSearchCache = () => {
  const cacheStr = sessionStorage.getItem(STORAGE_KEY);
  if (cacheStr) {
    try {
      const cache = JSON.parse(cacheStr);
      md.value = cache.md ?? "";
      pmname.value = cache.pmname ?? "";
    } catch (e) {
      sessionStorage.removeItem(STORAGE_KEY);
    }
  }
};

const formatDate = (date) => {
  if (!date) return "";
  const time = new Date(date);
  const year = time.getFullYear();
  const month = (time.getMonth() + 1).toString().padStart(2, "0");
  const day = time.getDate().toString().padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const mdList = async () => {
  try {
    const res = await proxy.$api.Colorcard.get({});
    if (res.data.code == "200") {
      menlist.value = res.data.data.list.filter(
        (item) => item.name !== "" && item.name !== null
      );
    } else {
      proxy.$message.error("获取门店列表失败");
      menlist.value = [];
    }
  } catch (error) {
    console.error("获取门店列表异常：", error);
    proxy.$message.error("网络错误，获取门店列表失败");
    menlist.value = [];
  }
};

const pmList = async () => {
  try {
    const res = await proxy.$api.Colorcard.gets({});
    if (res.data.code == "200") {
      pmlist.value = res.data.data.list;
    } else {
      proxy.$message.error("获取产品列表失败");
      pmlist.value = [];
    }
  } catch (error) {
    console.error("获取产品列表异常：", error);
    proxy.$message.error("网络错误，获取产品列表失败");
    pmlist.value = [];
  }
};

// 查询：重置页码清空列表
const search = () => {
  pages.value.page = 1;
  noMore.value = false;
  list.value = [];
  getList();
};
// 加载下一页
const loadMore = async () => {
  await getList(true);
};

// 改造getList，支持追加
const getList = async (isLoadMore = false) => {
  if (noMore.value || loading.value) return;
  const sendata = {
    currentPage: pages.value.page,
    pageSize: pages.value.size,
    storeId: md.value,
    productId: pmname.value,
  };
  try {
    loading.value = true;
    const res = await proxy.$api.Colorcard.getlist(sendata);
    if (res.data.code == 200) {
      const currentData = Array.isArray(res.data.data.list)
        ? res.data.data.list
        : [];
      if (pages.value.page === 1) {
        list.value = currentData;
      } else {
        list.value = [...list.value, ...currentData];
      }
      const total = res.data.data.total;
      noMore.value =
        total != null
          ? list.value.length >= total
          : currentData.length < pages.value.size;
      pages.value.page += 1;
    } else if (!isLoadMore) {
      list.value = [];
      proxy.$message.error("获取列表失败：" + (res.data.msg || "未知错误"));
    }
  } catch (error) {
    console.error("获取列表异常：", error);
    if (!isLoadMore) list.value = [];
  } finally {
    loading.value = false;
  }
};

const up = (row) => {
  dels();
  idx.value = row.id;
  upmd.value = row.storeId;
  uppmname.value = row.productId;
  num.value = row.number;
  dialogTableVisible.value = true;
};

//清除修改弹窗的值
const dels = () => {
  idx.value = "";
  upmd.value = "";
  uppmname.value = "";
  num.value = "";
};

const delUser = async (id) => {
  const sendata = { id: id };
  try {
    const res = await proxy.$api.Colorcard.del(sendata);
    if (res.data.code == 200) {
      proxy.$message.success("删除成功");
      // 删除成功重置回第一页
      pages.value.page = 1;
      noMore.value = false;
      list.value = [];
      getList();
    } else {
      proxy.$message.error("删除失败：" + (res.data.msg || "未知错误"));
    }
  } catch (error) {
    console.error("删除异常：", error);
    proxy.$message.error("网络错误，删除失败");
  }
};

const save = async () => {
  const sendata = {
    id: idx.value,
    storeId: upmd.value,
    productId: uppmname.value,
    number: num.value,
  };
  try {
    const res = await proxy.$api.Colorcard.updates(sendata);
    if (res.data.code == 200) {
      dialogTableVisible.value = false;
      proxy.$message.success("修改成功");
      // 修改成功重置回第一页
      pages.value.page = 1;
      noMore.value = false;
      list.value = [];
      getList();
    } else {
      proxy.$message.error("修改失败：" + (res.data.msg || "未知错误"));
    }
  } catch (error) {
    console.error("修改异常：", error);
    proxy.$message.error("网络错误，修改失败");
  }
};

onMounted(() => {
  mdList();
  pmList();
  loadSearchCache();
  getList();
});
</script>

<style lang="scss" scoped>
@import "./colorcardAddList.scss";
:deep(.custom-btn) {
  background-color: #ffae00 !important;
  border-color: #ffae00 !important;
  color: #333;
}
.main-panel.large {
  background-color: #fff;
}
:deep(.el-dialog) {
  margin-top: 15vh !important;
}
:deep(.el-dialog--center .el-dialog__body) {
  height: 180px;
}
.panel-title {
  color: #666;
}
:deep(.el-select .el-input__inner) {
  background-color: #fff;
}
:deep(.el-select .el-input__inner:focus) {
  background-color: #fff;
}
:deep(.custom-table) {
  background-color: #fff !important;
  .el-table__header-wrapper {
    background-color: #fff !important;
    .el-table__header {
      background-color: #fff !important;
      th {
        background-color: #fff !important;
      }
    }
  }
  .el-table__body-wrapper {
    background-color: #fff !important;
    .el-table__body {
      background-color: #fff !important;
      td {
        background-color: #fff !important;
      }
    }
  }
}
:deep(.el-dialog--center) {
  background-color: #fff !important;
}
/* 加载更多样式，和其他页面统一 */
.load-more {
  height: 50px;
  line-height: 50px;
  text-align: center;
  color: #666;
  cursor: pointer;
  &:hover {
    background: #e9ecef;
  }
  &.no-more {
    color: #999;
    cursor: default;
  }
}
</style>
